import _isEqual from 'lodash/isEqual';
import _uniqWithin from 'lodash/uniqWith';

/**
 * Handle survey dropdown list items
 * @param {string} ADM0 - Country name
 * @param {number} year - Survey year
 * @param {string} SurveyType - Survey type
 * @returns {string} - Survey dropdown label value
 */
export function getSurveyDropdownLabelValue(ADM0: string, year: number, SurveyType: string): string {
  return `${ADM0} ${SurveyType} ${year}`;
}

/**
 * Handle survey dropdown list items
 * @param {Object[]} surveyList - List of surveys
 */
export function getSurveysListUniq(surveyList: any) {
  return _uniqWithin(surveyList, _isEqual);
}
